import { Anchor } from "client/Components";
import { ReactElement, useMemo } from "react";
import { localize } from "client_legacy/ndaw/culture";
import { getRelativeEnvironmentUrl } from "client_legacy/ndaw/navigator";
import styles from "../ErrorPage.module.less";

export const BackToWorkspace = (): ReactElement => {
	const url = useMemo(
		(): string => {
			return getRelativeEnvironmentUrl();
		},
		[]
	);

	return (
		<section className={styles.section}>
			<p className={styles.sectionDescription}>
				{localize("_GoBackToWorkspace")}
			</p>
			<p className={styles.paragraph}>
				<Anchor
					href={url}
					className={styles.button}
				>
					{localize("_BackToWorkspace")}
				</Anchor>
			</p>
		</section>
	);
};
BackToWorkspace.displayName = "BackToWorkspace";